import React, {
  useEffect,
  useState,
  useRef,
  createContext,
  useContext,
} from 'react';
import { Link, useLocation } from 'react-router-dom';
import Logo from '../logo';
import {
  breakpoints,
  MediaQuery,
  SeoHiddenMediaQuery,
} from '../../../../utils/responsive_utilities';
import useClickOutside from '../../custom-hooks/useClickOutside';
import {
  EDUCATOR_PATH,
  HOME_PATH,
  PARENT_PATH,
  SIGNUP_PATH,
  SIGNIN_PATH,
  STUDENT_PATH,
  STUDENT_SIGNIN_PATH,
  PARENT_SIGNIN_PATH,
  TEACHER_SIGNIN_PATH,
} from '../../../../routes/route-paths';
import { eventHandler } from '../../../../utils/event-utils';
import EducatorMenu from '../educator-menu';
import CurriculumMenu from '../curriculum-menu';
import Image from '../../common/Image';
import connect from '../../../../stores/parent-dashboard';
import { trackToGtmFE } from '../../../../utils/gtm-event-common';

const HeaderContext = createContext();

const HeaderMobileTab = ({ appDownloadCTA, abTestsDetails, isTutoring, settings }) => {

  const [showMenu, setShowMenu] = useState(false);
  const headerRef = useRef(null);
  useClickOutside(headerRef, () => setShowMenu(() => false));
  const handleToggleMenu = () => {
    setShowMenu(() => !showMenu);
    trackToGtmFE('interacted_menu_mobile', {});
  };
  return (
    <HeaderContext.Provider
      value={{ showMenu, setShowMenu, handleToggleMenu }}
    >
      {showMenu && <div className="header-mobiletab-menu-overlay" />}
      <div ref={headerRef} className="header-mobiletab-header-wrapper">
        <HeaderContent appDownloadCTA={appDownloadCTA} abTestsDetails={abTestsDetails} isTutoring={isTutoring} settings={settings}/>
      </div>
    </HeaderContext.Provider>
  );
};
const HeaderContent = ({appDownloadCTA, abTestsDetails, isTutoring, settings}) => {
  const { setShowMenu } = useContext(HeaderContext);
  const location = useLocation();
  useEffect(() => {
    setShowMenu(false);
  }, [location]);
  switch (location.pathname) {
    case SIGNUP_PATH:
      return <ContentWithLoginOnly />;
    case SIGNIN_PATH:
      return <ContentWithNoLinks />;
    default:
      return <ContentWithAllLinks appDownloadCTA={appDownloadCTA} abTestsDetails={abTestsDetails} isTutoring={isTutoring} settings={settings}/>;
  }
};

const HamburgerIcon = () => {
  const { handleToggleMenu, showMenu } = useContext(HeaderContext);
  return (
    <div
      onClick={handleToggleMenu}
      className={`hamburger ${showMenu ? 'active' : ''}`}
    >
      <div className="header-mobiletab-burger-line header-mobiletab-burger-line1"></div>
      <div className="header-mobiletab-burger-line header-mobiletab-burger-line2"></div>
      <div className="header-mobiletab-burger-line header-mobiletab-burger-line3"></div>
    </div>
  );
};

const ContentWithNoLinks = () => {
  return (
    <div className="header-mobiletab-wrapper">
      <div>
        <Logo />
      </div>
    </div>
  );
};
const ContentWithAllLinks = ({appDownloadCTA, isTutoring, settings}) => {
  const [showSignup, setShowSignup] = useState(false);
  const [showEducatorMenu, setShowEducatorMenu] = useState(false);
  const [showCurriculumMenu, setShowCurriculumMenu] = useState(false);
  const [hrefLink, setHrefLink] = useState('')
  const [buttonText, setButtonText] = useState('')

  useEffect(() => {
    if(settings.currentUser){
      setHrefLink('/signout')
      setButtonText('Log out')
    }
    else{
      setHrefLink('/signin')
      setButtonText('Log In')
    }
  },[settings.currentUser])

  const { showMenu } = useContext(HeaderContext);
  let linkTarget = "_self";
  let sendAppDownloadCTAEvents = false;

  if(appDownloadCTA && appDownloadCTA.showAppDownloadCTA && location.pathname !== EDUCATOR_PATH){
    linkTarget = "_blank";
    sendAppDownloadCTAEvents = true;
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const educatorMenuToggle = () => {
    setShowEducatorMenu(() => !showEducatorMenu);
    trackToGtmFE('clicked_navigation', {'Click Text': "Educators"})
  };
  const curriculumMenuToggle = () => {
    setShowCurriculumMenu(() => !showCurriculumMenu);
    trackToGtmFE('clicked_navigation', {'Click Text':"Curriculum"})
  };
  const handleScroll = () => {
    let currentY = window.pageYOffset;
    setShowSignup(() => currentY > 285);
  };
  const handleLinkClicks = (type) => {
    eventHandler('interacted header', { clicked: type });
    trackToGtmFE('clicked_navigation', {'Click Text': "Parents",'Click URL': HOME_PATH});
  };

  const ctaClickHandler = (e, doNotSendEventProp=false) =>{
    trackToGtmFE('clicked_navigation', {'Click Text':e?.target?.innerText,'Click URL': e?.target?.href});
    if(sendAppDownloadCTAEvents){
      trackEventOnGA('Download Button Tapped',JSON.stringify({"From Page":"HomePage","Link Location":"Top Banner"}))
    }
  }
  const mobCtaClickHandler = (e) => {
    trackToGtmFE('clicked_navigation', {'Click Text': e?.target?.innerText,'Click URL': e?.target?.href});
  };

  const currentHeight = window.pageYOffset;
  return (
    <>
      <div className="header-mobiletab-wrapper">
        <HamburgerIcon />
        <div>
          <SeoHiddenMediaQuery
            query={`(min-width: ${(breakpoints.md+1)}px) and (max-width: 1279px)`}
          >
            <Logo />
          </SeoHiddenMediaQuery>
          <SeoHiddenMediaQuery query={`(max-width: ${breakpoints.md}px)`}>
            {
              !isTutoring &&
                (showSignup && !settings.currentUser ? (
                  <div className="header-mobiletab-signup-link-mobile" theme={{ white: true }} as="div">
                    <a href="/register" onClick={(e) => ctaClickHandler(e)} className="header-mobiletab-signup-link-mobile-a">
                      Sign up for free
                    </a>
                  </div>
                ) : (
                  <Logo />
                ))
            }
          </SeoHiddenMediaQuery>
        </div>
        <div className="ipad-signup">
          <MediaQuery
            query={`(min-width: ${(breakpoints.md+1)}px) and (max-width: 1279px)`}
          >
            <div className='header-mobiletab-container'>

            <div className="header-mobiletab-login-btn" theme={{ white: true }} as="div">
              <a href="/signin" target={linkTarget} onClick={(e) => ctaClickHandler(e,true)} className="header-mobiletab-login-a">Log in</a>
            </div>
            <div className="header-mobiletab-login-btn" theme={{ white: true }} as="div">
              <a href="/register" target={linkTarget} onClick={(e) => ctaClickHandler(e,true)} className={`header-mobiletab-login-a ${isTutoring && (currentHeight > window.innerHeight) ? "tutoring-signup-btn" : ""}`}>Sign up </a>
            </div>

            </div>

          </MediaQuery>
        </div>
      </div>
      {showMenu ? (
        // small width menu will appear in phase 2 when all the links will appear in the menu
        // for now its fullWidth
        <div className="header-mobiletab-menu" fullWidth>
          <ul>
            <li>
              <Link to={HOME_PATH} onClick={() => handleLinkClicks('parent')} className="header-mobiletab-a">
                Parents
              </Link>
            </li>

            <li onClick={() => educatorMenuToggle()} className={showEducatorMenu ? 'open' : 'closed'} >
              <span className="dropdown">Educators</span>
              <span className="mobile-arrow"></span>
              <EducatorMenu />
            </li>
            <li onClick={curriculumMenuToggle} className={showCurriculumMenu ? 'open' : 'closed'} >
              <span className="dropdown">Curriculum</span>
              <span className="mobile-arrow"></span>
              <CurriculumMenu />
            </li>
            {/* <li>Curriculum</li>
            <li>Membership</li> */}
            { (location.pathname !== SIGNIN_PATH && location.pathname !== STUDENT_SIGNIN_PATH && location.pathname !== STUDENT_PATH && location.pathname !== PARENT_SIGNIN_PATH && location.pathname !== TEACHER_SIGNIN_PATH) &&
            <li id="btn">
              <a href={`${hrefLink}` + ((location.pathname === PARENT_PATH) ? '?userType=parent' : '')} className="header-mobiletab-a " onClick={(e) => mobCtaClickHandler(e)}>{buttonText}</a>
            </li>
            }
          </ul>
        </div>
      ) : null}
    </>
  );
};
const ContentWithLoginOnly = () => {
  const { showMenu } = useContext(HeaderContext);
  return (
    <>
      <div className="header-mobiletab-wrapper">
        <HamburgerIcon />
        <div>
          <Logo />
        </div>
      </div>
      {showMenu ? (
        <div className="header-mobiletab-menu" fullWidth>
          <ul>
            <li>
              <a href="/signin" className="header-mobiletab-a">Login</a>
            </li>
          </ul>
        </div>
      ) : null}
    </>
  );
};

function mapStateToProps(state) {
  return {
    settings: state.settings
  };
}

export default connect(mapStateToProps, null, HeaderMobileTab);
